export default "__VITE_ASSET__acf533ca__"